import {
  LayoutContextProvider,
  RoomContext,
  useCreateLayoutContext,
  type WidgetState,
} from "@livekit/components-react";
import { CustomControlBar } from "./CustomControlBar";
import { FocusVideoConference } from "./FocusVideoConference";
import SignedNotification from "./SignedNotification";
import type { Room } from "livekit-client";
import { useState } from "react";
import { Chat } from "./CustomChat";

const CHAT_WIDTH = 300;

export const InCallContainer = ({
  room,
  remoteSigningLink,
  showSignedNotification,
}: {
  room: Room;
  remoteSigningLink: string | null;
  showSignedNotification: boolean;
}) => {
  const isMobile = window.innerWidth < 768;
  const [widgetState, setWidgetState] = useState<WidgetState>({
    showChat: false,
    unreadMessages: 0,
    showSettings: false,
  });

  const widgetUpdate = (state: WidgetState) => {
    setWidgetState(state);
  };

  const layoutContext = useCreateLayoutContext();

  return (
    <section
      id="session-section"
      className="w-full h-[100dvh] flex flex-col items-center"
    >
      <RoomContext.Provider value={room}>
        <LayoutContextProvider
          value={layoutContext}
          onWidgetChange={widgetUpdate}
        >
          <div className="w-full h-[100dvh] flex flex-row">
            {widgetState.showChat && (
              <div
                className={`flex min-h-full  items-stretch w-[${CHAT_WIDTH}px]`}
                style={
                  isMobile
                    ? { position: "absolute", top: 0, left: 0, zIndex: 1000 }
                    : {}
                }
              >
                <Chat />
              </div>
            )}
            <div className="flex h-[100dvh] flex-col w-full">
              <div className="flex-1 min-h-100 grid items-stretch gap-3 p-2">
                <div className="abc-room min-w-0 min-h-100 flex flex-row">
                  <FocusVideoConference
                    focusedContent={
                      remoteSigningLink ? (
                        <iframe
                          src={remoteSigningLink}
                          className="w-full h-[calc(100vh-108px)] rounded-md"
                          title="Sign consent"
                        />
                      ) : undefined
                    }
                    signedNotification={
                      showSignedNotification ? (
                        <SignedNotification />
                      ) : undefined
                    }
                  />
                </div>
              </div>

              <CustomControlBar className="bg-[#181818]" />
            </div>
          </div>
        </LayoutContextProvider>
      </RoomContext.Provider>
    </section>
  );
};
